module.exports = __webpack_public_path__ + "media/icons/sprowadzony-grey@3x-0655a1db.svg";